import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';
import { relationGroupsTableActions } from './relationGroupsTable.actions';

export const addRelationGroupAction = {
    addData
};

function addData(data) {

    return dispatch => {
        dispatch(request());
        relationGroupsService.addRelationGroup(data)
            .then(
                relationGroup => {
                    dispatch(relationGroupsTableActions.getRelationGroups());
                    dispatch(success(relationGroup));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: relationGroupsConstants.REQUEST_ADD_RELATION_GROUP } }
    function success(relationGroup) { return { type: relationGroupsConstants.RECEIVE_ADD_RELATION_GROUP, relationGroup } }
    function failure(error) { return { type: relationGroupsConstants.ADD_RELATION_GROUP_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/addRelationGroup.action.js